const mdpConfig = require('../../mdp.config');

const addProductsGlobalId = (id, config) => {
  // console.info('addProductsGlobalId', id, config);
  let newId;
  if (config.routes) {
    config.routes.forEach((route) => {
      newId = id !== '' ? `${id}-${route.id}` : route.id;
      // if (route.routes) {
      addProductsGlobalId(newId, route);
      // }
    });
  }
  if (config.products) {
    config.products.forEach((product) => {
      newId = id !== '' ? `${id}-${product.id}` : product.id;
      product.globalId = `${newId}`; //eslint-disable-line
    });
  }
};

export const serverInit = async ({ commit, getters }, version) => { // eslint-disable-line
  const config = mdpConfig[version];
  commit('setVersion', version);
  addProductsGlobalId('', config);
  commit('setConfig', config);
  const products = getters.getProducts;
  commit('setTokenPrices', products);
  commit('setInit', true);
};

